module.exports = __webpack_public_path__ + "img/mute_group.3f301d85.png";